import React, { useRef } from "react"
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai"
import { WorkCarousel } from ".."
import Empty from "components/Empty"

export default ({
  data,
  setLoading,
  FullImage,
  xButton,
  withVievBtn,
  handleDelete,
  setRefresh,
}) => {
  const prevRef = useRef(null)
  const nextRef = useRef(null)
  return (
    <div>
      <div className="relative top-0 w-full">
        {data?.length > 0 ? (
          <div className="pt-4">
            <WorkCarousel
              setRefresh={setRefresh}
              withVievBtn={withVievBtn}
              handleDelete={handleDelete}
              data={data}
              setLoading={setLoading}
              FullImage={FullImage}
              xButton={xButton}
              prevRef={prevRef}
              nextRef={nextRef}
            />
            <button
              ref={prevRef}
              className="hidden md:block absolute top-1/2 -left-6 text-2xl text-primary-text-color rounded-full bg-white p-3 hover:text-white hover:bg-[color:var(--custom-primary)] shadow-md hover:shadow-[color:var(--custom-primary)] z-20"
            >
              <AiOutlineLeft aria-hidden="true" />
            </button>
            <button
              ref={nextRef}
              className="hidden md:block absolute top-1/2 -right-6 text-2xl text-primary-text-color rounded-full bg-white p-3 hover:text-white hover:bg-[color:var(--custom-primary)] shadow-md hover:shadow-[color:var(--custom-primary)] z-20"
            >
              <AiOutlineRight aria-hidden="true" />
            </button>

            <div className="flex items-center justify-between my-2 md:hidden">
              <div className="flex items-center justify-end w-full gap-5 px-1 py-2 text-right text-black md:hidden">
                <button
                  ref={prevRef}
                  className="md:hidden text-2xl text-secondary-text-color rounded-full bg-white p-3 hover:text-white hover:bg-[color:var(--custom-secondary)] shadow-md hover:shadow-[color:var(--custom-secondary-hover)] z-20"
                >
                  <AiOutlineLeft aria-hidden="true" />
                </button>
                <button
                  ref={nextRef}
                  className="md:hidden text-2xl text-secondary-text-color rounded-full bg-white p-3 hover:text-white hover:bg-[color:var(--custom-secondary)] shadow-md hover:shadow-[color:var(--custom-secondary-hover)] z-20"
                >
                  <AiOutlineRight aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        ) : (
          <Empty message="Қидирув бўйича хеч қандай натижа топилмади!" />
        )}
      </div>
    </div>
  )
}
